import { HttpBackend, HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { IAppSession, IFingerPrint, IPutRecord, ITransactions } from '../../core/models/app.model';
import { HandleTokenService } from '../../core/services/handle-token.service';
import { REQUEST_MOCK_KILL_PURCHASE as MOCK_KILL, REQUEST_MOCK_TRANSACTION, REQUEST_PATCH_TRANSACTION } from '../mocks/app-control.mock';
import { ServerMock } from '../mocks/app-serve.mock';
import { URLS } from './url.constants';
import { TRANSACTIONS_MOCK } from '../mocks/data/transactions';

const API_URL = environment.api_url;

@Injectable({
  providedIn: 'root',
})
export class AppAPI {
  private _httpClient: HttpClient;
  private _localServer: ServerMock = new ServerMock();

  constructor(
    private _httpBackend: HttpBackend,
    private _http: HttpClient,
    private _handleTokenService: HandleTokenService
  ) {
    this._httpClient = new HttpClient(_httpBackend);
  }

  private _setTransactionHeaders(transactionToken: string):
    | HttpHeaders
    | {
        [header: string]: string | string[];
      } {
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${transactionToken}`,
    };
  }

  public getTransactions(transactionToken: string): Observable<ITransactions> {
    const options = {
      headers: this._setTransactionHeaders(transactionToken),
    };
    const { production, isTestServer } = environment;
    const httpRequest: any = REQUEST_MOCK_TRANSACTION;
    return production && !isTestServer
    ? this._httpClient.get<ITransactions>(`${API_URL}/app/transactions`, options)
    : this._localServer.request(httpRequest).pipe(
        map((response: HttpResponse<any>) => {
          const data: ITransactions = response?.body;
          return data;
        })
      );
  }
  public setFingerPrintData(dataFingerPrint: IFingerPrint): Observable<ITransactions> {
    const accessToken = !!this._handleTokenService.getTransactionId()
      ? this._handleTokenService.getTransactionId().toString()
      : '';
    const options = {
      headers: this._setTransactionHeaders(accessToken),
    };

    const { production, isTestServer } = environment;
    const httpRequest: any = REQUEST_PATCH_TRANSACTION;
    return production && !isTestServer
    ? this._httpClient.patch<ITransactions>(
      `${API_URL}/app/transactions`,
      dataFingerPrint,
      options
    )
    : this._localServer.request(httpRequest).pipe(
        map((response: HttpResponse<any>) => {
          const data: ITransactions = response?.body;
          return data;
        })
      );
  }

  public requestLogin(
    phone: string,
    code: string,
    transactionId: string,
    offerId: string
  ): Observable<IAppSession> {
    const data = {
      phone_number: phone,
      code,
      transaction_id: transactionId,
      offer_id: offerId,
    };
    return this._http.post<IAppSession>(`${URLS.LOGIN}`, data);
  }

  public killPurchase() {
    const accessToken = !!this._handleTokenService.getTransactionId()
      ? this._handleTokenService.getTransactionId().toString()
      : '';
    const data = {
      status: 'canceled',
    };

    const options = {
      headers: this._setTransactionHeaders(accessToken),
    };
    const { production, isTestServer } = environment;
    const httpRequest: any = REQUEST_PATCH_TRANSACTION;
    return production && !isTestServer
    ? this._httpClient.patch(`${API_URL}${URLS.MERCHANT_TRANSACTIONS}`, data, options)
    : this._localServer.request(httpRequest).pipe(
        map((response: HttpResponse<any>) => {
          const data: ITransactions = response?.body;
          return data;
        })
      );
    
  }

  public sendPutRecord(data: IPutRecord) {
    const { production, isTestServer } = environment;
    return production && !isTestServer
      ? this._httpClient.post(`${API_URL}${URLS.PUT_RECORD}`, data).subscribe()
      : of({});
  }

  public setPaymentErrorCode(): Observable<any> {
    const accessToken = !!this._handleTokenService.getTransactionId()
      ? this._handleTokenService.getTransactionId().toString()
      : '';
    const data = {
      payment_error_code: '',
    };

    const options = {
      headers: this._setTransactionHeaders(accessToken),
    };
    const { production, isTestServer } = environment;
    const httpRequest: any = REQUEST_PATCH_TRANSACTION;
    return production && !isTestServer
    ? this._httpClient.patch(`${API_URL}${URLS.MERCHANT_TRANSACTIONS}`, data, options)
    : this._localServer.request(httpRequest).pipe(
        map((response: HttpResponse<any>) => {
          const data: ITransactions = response?.body;
          return data;
        })
      );
  }
}
